import { createSelector } from 'reselect'

export const FAVORITES_ID = 'favorites'
export const ALL_ID = 'all'

export const FAVORITES_LABEL = '★ Favorites'
export const ALL_LABEL = 'All'

/**
 * Current menu's item favorites
 *
 * @param {State} state
 * @returns {Object} - Favorites object with itemID as key and categoryIDs as values
 */
export const getItemFavorites = createSelector(
  (state) => state.appState?.currentMenuId,
  (state) => state.VNCategories?.favoritesByMenuId,
  (curMenu, favoritesByMenuId) => {
    if (!curMenu) return {}
    return favoritesByMenuId?.[curMenu] || {}
  },
)

export const getLastUpdatedFavorites = (state) => state.VNCategories?.lastUpdated || null

/**
 * Returns the currently selected category
 *
 * @param {State} state
 * @returns {Boolean}
 */
export const getSelectedCategory = (state) => {
  if (state.VNCategories?.selectedCategory) {
    return state.VNCategories.selectedCategory
  }

  return ALL_ID
}

/**
 * Returns the current category search term query
 *
 * @param {State} state
 * @returns {String}
 */
export const getCategorySearch = createSelector(
  (state) => state.VNCategories?.categorySearchterm,
  (categorySearchterm) => categorySearchterm || '',
)
